export enum LogicalOperators {
    AND = '$and',
    OR = '$or',
    NOT = '$not',
}

export enum AttributeOperators {
    EQUAL_TO = '$eq',
    EQUAL_TO_CASE_INSENSITIVE = '$eqi',
    NOT_EQUAL_TO = '$ne',
    NOT_EQUAL_TO_CASE_INSENSITIVE = '$nei',
    INCLUDES_IN = '$in',
    NOT_INCLUDES_IN = '$notIn',
    LESS_THAN = '$lt',
    LESS_THAN_EQUAL_TO = '$lte',
    GREATER_THAN = '$gt',
    GREATER_THAN_EQUAL_TO = '$gte',
    BETWEEN = '$between',
    CONTAINS = '$contains',
    NOT_CONTAINS = '$notContains',
    STARTS_WITH = '$startsWith',
    ENDS_WITH = '$endsWith',
    IS_NULL = '$null',
    IS_NOT_NULL = '$notNull'
}

export enum SortBy {
    PUBLISHED_AT = 'publishedAt',
    CREATED_AT = 'createdAt',
}

export enum Order {
    ASCENDING = 'asc',
    DESCENDING = 'desc',
}

export enum KeyType {
    TOPICS_URL = 'topics.url',
    URL = 'url',
    SLUG = 'slug'
}

export enum ComponentTypes {
    NewsAdEmbedded = 'relation.news-ad-embedded',
    BlogAdEmbed = 'relation.blog-ad-embed',
    ReviewsAdEmbedded = 'relation.reviews-ad-embedded',
    RichTextCK = 'text-editor.rich-text-ck',
    BlogAdCollapsible = 'relation.blog-ad-collapsible',
    BlogAdTC = 'relation.blog-ad-tc',
    BlogAdSWC = 'relation.blog-ad-swc'
}
